// @flow
import { API } from 'api/api'
import { makeGetRequest, makePostFileRequest } from 'api/fetchCalls'
import type { Form } from 'types/form'
import type { FormCreationRequest } from 'types/form-creation-request'

type FormsResponse = Promise<{
  count: number,
  results: Array<Form>,
}>

export async function getForms(): FormsResponse {
  return await makeGetRequest(API.FORM.GET_FORMS(100))
}

export async function getFormsToConvert(): Promise<Array<FormCreationRequest>> {
  return await makeGetRequest(API.FORM.CONVERT_FORMS)
}

export async function convertForms(formData: FormData): Promise<{}> {
  return await makePostFileRequest(API.FORM.CONVERT_FORMS, {
    body: formData,
  })
}
